import type { GesCloudMemberAiAgentAccess } from "@ext/enterprise-cloud/GesCloudApi";
import t from "@ext/localization/locale/translate";
import { Switch } from "@ui-kit/Switch";
import { useCallback, useState } from "react";

interface AiAgentAccessSwitchProps {
	member: GesCloudMemberAiAgentAccess;
	onChange: (email: string, aiAgentAccess: boolean) => Promise<void>;
}

export const AiAgentAccessSwitch = ({ member, onChange }: AiAgentAccessSwitchProps) => {
	const [isSaving, setIsSaving] = useState(false);

	const handleCheckedChange = useCallback(
		async (checked: boolean) => {
			setIsSaving(true);
			try {
				await onChange(member.email, checked);
			} finally {
				setIsSaving(false);
			}
		},
		[member.email, onChange],
	);

	return (
		<Switch
			aria-label={t("enterprise-cloud.org-settings.ai-wallet.access.column")}
			checked={member.aiAgentAccess}
			disabled={member.isOwner || isSaving}
			onCheckedChange={handleCheckedChange}
			size="sm"
		/>
	);
};
